import { SetStateAction } from 'react';
import { connect } from 'react-redux';
import { setSearchSectionPage } from 'redux/modules/search';
import { RootState } from 'redux/modules/types';
import {
  SEARCH_EXERCISE_PER_PAGE_DETAIL,
  SEARCH_EXERCISE_PER_PAGE_MASTER,
} from 'utils/config';
import { getPageCount } from 'utils/getPageCount';
import { OwnProps } from './types';

const mapStateToProps = (state: RootState, { isDetail }: OwnProps) => ({
  available: state.search.available.exercises,
  count: state.search.count.exercises,
  exercises: state.search.ids.exercises
    .map((id) => state.search.byId.exercises[id])
    .filter((it): it is NonNullable<typeof it> => !!it),
  loading: state.search.loading.exercises,
  page: state.search.page.exercises,
  pageCount: getPageCount(
    state.search.count.exercises,
    isDetail
      ? SEARCH_EXERCISE_PER_PAGE_DETAIL
      : SEARCH_EXERCISE_PER_PAGE_MASTER,
  ),
});

const mapDispatchToProps = {
  setPage: (page: SetStateAction<number>) =>
    setSearchSectionPage({
      page,
      section: 'exercises',
    }),
};

export default connect(mapStateToProps, mapDispatchToProps);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;
